import { defineStore } from 'pinia'

const STATE = () => ({
  widget: null,
  options: {
    gridSizes: [],
    distanceMeasures: [],
    pointDistances: {},
    kinds: [],
    scriptUrl: null,
    whiteLabelConfigurations: []
  }
})

export const useWidgetFormStore = defineStore('geogridWidgetForm', {
  state: STATE,
  getters: {
    isEdit: (state) => Boolean(state.widget?.id),

    currentPointDistances: (state) =>
      state.options.pointDistances[state.widget?.gridDistanceMeasure] || []
  },
  actions: {
    setOptions(options) {
      this.options = { ...this.options, ...options }
    },

    setWidget(widget) {
      this.widget = { ...widget }
    },

    // Measures have disjoint distance catalogs, so switching invalidates the
    // current pick — fall back to the first option of the new measure.
    setDistanceMeasure(measure) {
      this.widget.gridDistanceMeasure = measure
      this.widget.gridPointDistance = this.currentPointDistances[0]?.id ?? null
    }
  }
})
